import React, { useState } from "react";
import "../styles/Contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    message: "",
  });

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  // ---------- HANDLE INPUT CHANGE (NO TRIM HERE) ----------
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // ---------- HANDLE FORM SUBMIT ----------
  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      name: formData.name.trim(),
      email: formData.email.trim(),
      phone: formData.mobile.trim(),     // backend expects "phone"
      purpose: formData.message.trim(),  // store message in purpose column
    };

    if (!payload.name || !payload.email || !payload.phone) {
      alert("Name, Email & Mobile are required!");
      return;
    }

    try {
      setLoading(true);

      const res = await fetch(
        `${process.env.REACT_APP_CONTACT_API_URL}?action=add`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      const data = await res.json();

      if (data.success) {
        setSubmitted(true);
        setFormData({ name: "", mobile: "", email: "", message: "" });

        setTimeout(() => setSubmitted(false), 3000);
      } else {
        alert(data.message || "Failed to submit form.");
      }
    } catch (err) {
      console.error("Error submitting contact:", err);
      alert("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page-container">
      {/* Header Section */}
      <section className="contact-top-section">
        <h6 className="contact-page-sub-head">Tax TimeZ</h6>
        <p className="contact-top-para">
          Have questions regarding taxation, registration, accounting, auditing,
          or compliance? We're here to assist you.
        </p>
      </section>

      {/* Contact Info Section */}
      <section className="contact-info-section">
        <div className="contact-info-card">
          <h2 className="color">📞 Phone</h2>
          <p>+91 8500851930</p>
        </div>

        <div className="contact-info-card">
          <h2 className="color">📧 Email</h2>
          <p>19taxtimez@gmail.com</p>
        </div>

        <div className="contact-info-card">
          <h2 className="color">📍 Office Address</h2>
          <p>
            H.O - 12-12, MIG -58, Above SBI Bank, Opposite to Collectorate
            Sangareddy, Telangana - 502001
          </p>
          <p>B.O - Sadasivpet & Vikarabad</p>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="contact-form-section">
        <h2 className="contact-sub-heading">Send Us a Message</h2>

        <form className="contact-form" onSubmit={handleSubmit}>
          <label htmlFor="name">Name *</label>
          <input
            type="text"
            id="name"
            name="name"
            placeholder="Enter your name"
            value={formData.name}
            onChange={handleChange}
            required
          />

          <label htmlFor="mobile">Mobile Number *</label>
          <input
            type="tel"
            id="mobile"
            name="mobile"
            placeholder="Enter mobile number"
            pattern="[0-9]{10}"
            value={formData.mobile}
            onChange={handleChange}
            required
          />

          <label htmlFor="email">Email *</label>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Enter your email"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <label htmlFor="message">Message</label>
          <textarea
            id="message"
            name="message"
            placeholder="Write your message..."
            rows="5"
            value={formData.message}
            onChange={handleChange}
          ></textarea>

          <button type="submit" disabled={loading}>
            {loading ? "Submitting..." : "Submit"}
          </button>
        </form>

        {submitted && (
          <p className="thankyou-msg">
            Thank you! We will get back to you soon.
          </p>
        )}
      </section>
    </div>
  );
};

export default Contact;
